import { render, staticRenderFns } from "./GetPrizeMirror.vue?vue&type=template&id=832c448c&scoped=true&"
import script from "./GetPrizeMirror.vue?vue&type=script&lang=js&"
export * from "./GetPrizeMirror.vue?vue&type=script&lang=js&"
import style0 from "./GetPrizeMirror.vue?vue&type=style&index=0&id=832c448c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832c448c",
  null
  
)

export default component.exports